export interface AulaLink {
  title: string;
  url: string;
  platform: "youtube" | "outro";
  duration: string;
  teacher: string;
  isFree: boolean;
}

export interface TopicAulas {
  topic: string;
  aulas: AulaLink[];
}

export interface SubjectAulas {
  subject: string;
  topics: TopicAulas[];
}

export interface ExamAulas {
  id: string;
  name: string;
  institution: string;
  banca: string;
  year: string;
  status: "ativo" | "em-breve";
  subjects: SubjectAulas[];
}

const yt = (query: string) => `https://www.youtube.com/results?search_query=${encodeURIComponent(query)}`;

const mkAula = (title: string, query: string, duration = "20-45 min"): AulaLink => ({
  title,
  url: yt(query),
  platform: "youtube",
  duration,
  teacher: "Curadoria Concurseiro Pobre (mock)",
  isFree: true,
});

export const EXAM_AULAS_MOCK: ExamAulas[] = [
  {
    id: "pmerj-2026",
    name: "PMERJ - Soldado",
    institution: "Polícia Militar do Estado do Rio de Janeiro",
    banca: "FGV",
    year: "2026",
    status: "ativo",
    subjects: [
      {
        subject: "Língua Portuguesa",
        topics: [
          { topic: "Interpretação de textos", aulas: [mkAula("Interpretação para concursos PMERJ", "interpretação de textos concursos PMERJ") ] },
          { topic: "Ortografia e classes de palavras", aulas: [mkAula("Ortografia + classes de palavras", "ortografia classes de palavras concurso policial") ] },
          { topic: "Sintaxe, concordância e regência", aulas: [mkAula("Sintaxe, concordância e regência", "sintaxe concordância regência concursos") ] },
          { topic: "Crase e colocação pronominal", aulas: [mkAula("Crase e colocação pronominal", "crase colocação pronominal concursos") ] },
        ],
      },
      {
        subject: "Matemática Básica",
        topics: [
          { topic: "Operações com números e proporções", aulas: [mkAula("Números inteiros, racionais e proporção", "matemática básica concursos números razão proporção") ] },
          { topic: "Porcentagem, juros e probabilidade", aulas: [mkAula("Porcentagem, juros e probabilidade", "porcentagem juros probabilidade concurso") ] },
          { topic: "Equações e sistema do 1º grau", aulas: [mkAula("Equação e sistema 1º grau", "equação sistema primeiro grau concursos") ] },
          { topic: "Geometria e Pitágoras", aulas: [mkAula("Geometria básica + Teorema de Pitágoras", "geometria teorema de pitágoras concurso") ] },
        ],
      },
      {
        subject: "Noções de Direitos Humanos",
        topics: [
          { topic: "DUDH e Art. 5º da CF/88", aulas: [mkAula("DUDH + Direitos e garantias fundamentais", "DUDH artigo 5 constituição concursos") ] },
          { topic: "Tratados internacionais e controle de convencionalidade", aulas: [mkAula("Tratados e controle de convencionalidade", "controle de convencionalidade direitos humanos") ] },
          { topic: "Lei de Tortura e prevenção", aulas: [mkAula("Lei 9.455/97 + Lei 12.847/2013", "lei de tortura concursos segurança pública") ] },
          { topic: "Estatuto de Roma e Lei 13.060/2014", aulas: [mkAula("Estatuto de Roma e uso progressivo da força", "estatuto de roma lei 13060 2014") ] },
        ],
      },
      {
        subject: "Direito Administrativo",
        topics: [
          { topic: "Conceito, fontes e princípios", aulas: [mkAula("Direito Administrativo: conceitos e princípios", "direito administrativo princípios concursos") ] },
          { topic: "Organização administrativa e órgãos públicos", aulas: [mkAula("Administração pública direta e indireta", "organização administrativa órgãos públicos") ] },
          { topic: "Poderes administrativos", aulas: [mkAula("Poder de polícia, hierárquico e disciplinar", "poderes administrativos concurso") ] },
          { topic: "Ato administrativo", aulas: [mkAula("Ato administrativo completo", "ato administrativo elementos atributos extinção") ] },
          { topic: "Processo administrativo e PAD", aulas: [mkAula("Processo administrativo e PAD", "processo administrativo PAD concursos") ] },
        ],
      },
      {
        subject: "Legislação Aplicada à PMERJ",
        topics: [
          { topic: "CF e CE-RJ (arts. cobrados)", aulas: [mkAula("CF/88 e CE-RJ para PMERJ", "artigo 42 144 125 constituição polícia militar") ] },
          { topic: "Decreto-Lei 667/1969", aulas: [mkAula("Lei de organização das Polícias Militares", "decreto lei 667 1969 PM") ] },
          { topic: "Estatuto dos Policiais Militares (Lei 443/1981)", aulas: [mkAula("Estatuto PMERJ Lei 443/81", "lei 443 1981 PMERJ") ] },
          { topic: "Sistema de Proteção Social e remuneração", aulas: [mkAula("SPSMERJ e remuneração", "lei 9537 2021 SPSMERJ lei 279 1979") ] },
        ],
      },
      {
        subject: "Direito Penal",
        topics: [
          { topic: "Parte Geral", aulas: [mkAula("Parte Geral do Direito Penal", "direito penal parte geral concursos") ] },
          { topic: "Crimes em espécie (Parte Especial)", aulas: [mkAula("Crimes contra pessoa, patrimônio e administração", "parte especial direito penal concursos") ] },
          { topic: "Leis penais especiais", aulas: [mkAula("Leis penais especiais mais cobradas", "leis penais especiais concurso policial") ] },
        ],
      },
      {
        subject: "Direito Processual Penal",
        topics: [
          { topic: "Disposições preliminares, inquérito e ação penal", aulas: [mkAula("CPP introdutório + inquérito + ação penal", "cpp inquérito ação penal concurso") ] },
          { topic: "Provas, perícia e cadeia de custódia", aulas: [mkAula("Provas no CPP + cadeia de custódia", "prova cadeia de custódia cpp") ] },
          { topic: "Sujeitos do processo, prisão e cautelares", aulas: [mkAula("Prisão, cautelares e liberdade provisória", "prisão cautelares liberdade provisória cpp") ] },
        ],
      },
    ],
  },
  {
    id: "pcerj-placeholder",
    name: "PCERJ - (em breve)",
    institution: "Polícia Civil do Estado do RJ",
    banca: "A definir",
    year: "2026",
    status: "em-breve",
    subjects: [],
  },
];
